import Slider from '@mui/material/Slider';
import { styled as muiStyled } from '@mui/material/styles';
import { theme } from 'twin.macro';

const RiskSlider = muiStyled(Slider)(() => {
  return {
    color: theme('colors.primary'),
    height: 10,
    paddingBottom: '0 !important',
    '& .MuiSlider-thumb': {
      height: 20,
      width: 20,
      backgroundColor: theme('colors.primary'),
      '&::before': {
        boxShadow: 'none',
      },
    },
    '& .MuiSlider-valueLabel': {
      fontSize: 12,
      fontWeight: 'normal',
      top: 0,
      backgroundColor: 'unset',
      color: theme('colors.primary'),
      '&:before': {
        display: 'none',
      },
    },
    '& .MuiSlider-track': {
      border: 0,
      opacity: 0,
    },
    '& .MuiSlider-rail': {
      background: `linear-gradient(90deg, ${theme('colors.primary')}, ${theme('colors.caution')})`,
      opacity: 0.2,
    },
  };
});
export default RiskSlider;
